import { memo } from 'react';
import cls from 'classnames';

import styles from './SpinnerLoader.module.scss';

interface SpinnerLoaderProps {
  size?: StringOrNumber;
  strokeWidth?: StringOrNumber;
  className?: string;
}

function SpinnerLoader(props: SpinnerLoaderProps) {
  const { className, size = 66, strokeWidth = 6 } = props;

  return (
    <svg className={cls(styles.spinner, className)} width={size} height={size} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle className={styles.circle} fill="none" strokeWidth={strokeWidth} strokeLinecap="round" cx="33" cy="33" r="30"></circle>
    </svg>
  );
}

export default memo(SpinnerLoader);
